export default function checkIfEdge() {
  // Based on http://browserhacks.com/
  return (
    !!('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) || // IE 11
    !!(document.all && document.compatMode)
  ); // IE6-10
}
